import { defaultWidgets } from './default-widgets';

export const widgets = [
  ...defaultWidgets,
];
